import type { IModalityService } from '@/services/interfaces/IModalityService'
import type { SportModality } from '@/types/address'

const mockModalities: SportModality[] = [
  { id: '1', name: 'Futebol' },
  { id: '2', name: 'Basquete' },
  { id: '3', name: 'Vôlei' },
  { id: '4', name: 'Tênis' },
  { id: '5', name: 'Futsal' },
  { id: '6', name: 'Beach Tennis' },
  { id: '7', name: 'Padel' },
  { id: '8', name: 'Corrida' },
  { id: '9', name: 'Ciclismo' },
  { id: '10', name: 'Natação' },
  { id: '11', name: 'Surf' },
  { id: '12', name: 'Skate' },
  { id: '13', name: 'Escalada' },
  { id: '14', name: 'Crossfit' },
  { id: '15', name: 'Musculação' },
  { id: '16', name: 'Yoga' },
  { id: '17', name: 'Pilates' },
  { id: '18', name: 'Boxe' },
  { id: '19', name: 'Muay Thai' },
  { id: '20', name: 'Jiu-Jitsu' },
  { id: '21', name: 'Capoeira' },
  { id: '22', name: 'Handball' },
  { id: '23', name: 'Rugby' },
  { id: '24', name: 'Hockey' },
  { id: '25', name: 'Ping Pong' },
  { id: '26', name: 'Badminton' },
  { id: '27', name: 'Squash' },
  { id: '28', name: 'Dança' },
  { id: '29', name: 'Academia' },
  { id: '30', name: 'Atletismo' }
]

export class MockModalityService implements IModalityService {
  async getModalities(): Promise<SportModality[]> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500))

    // Sometimes simulate an error for testing
    if (Math.random() < 0.1) { // 10% chance of error
      throw new Error('Erro ao carregar modalidades. Tente novamente.')
    }

    return mockModalities
  }
}